module.exports = __webpack_public_path__ + "static/img/xj_img5.b6094aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xj_img5.jpg
// module id = qMnJ
// module chunks = 4